// @core/api/endpoints/chat/get_chat_policy_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ChatPolicyResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Get entity chat policy
 * Returns the chat policy directly attached to the specified entity (if any). Does NOT resolve inheritance — use ResolveChatContext for that.
 */
export async function GetChatPolicyByEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<ChatPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/chat/:entity_type/:entity_id/policy`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<ChatPolicyResponse>(requestPath, { ...requestOptions });
}
